<template>
    <div class="modal bd-example-modal-lg fade show" tabindex="-1" role="dialog" aria-hidden="true" style="display: block; opacity: 1">
        <div class="modal-dialog modal-dialog-centered modal-queue-details" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">"{{ queue.name }}" - details</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onClose">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" v-if="queueInfo">
                    <!--<div class="row" v-if="queueInfo">-->
                        <!--<div class="col-sm-6">-->
                            <!--<strong>Worker name:</strong> <span>{{queueInfo.worker}}</span> <br>-->
                            <!--<strong>Process number:</strong> {{queueInfo.process}} <br>-->
                        <!--</div>-->
                        <!--<div class="col-sm-6">-->
                            <!--<strong>Reserved number: </strong>  {{queueInfo.reservedNumber}} <br>-->
                            <!--<strong>Pending number: </strong>  {{queueInfo.pendingNumber}} <br>-->
                        <!--</div>-->
                    <!--</div>-->
                    <!--<div class="row" v-else>-->
                        <!--<div class="col-xs-12">-->
                            <!--<p class="p-3 mb-2 bg-danger text-white">-->
                                <!--Queue info not found, please parse workers config once again.-->
                            <!--</p>-->
                        <!--</div>-->
                    <!--</div>-->
                    <!--<hr />-->
                    <div class="row">
                        <div class="col">
                            <h4>Reserved jobs ({{queueInfo.items.reserved.length || 0}})</h4>
                            <table class="table table-sm" v-if="queueInfo && queueInfo.items && queueInfo.items.reserved">
                                <thead class="thead-light">
                                    <th>#</th>
                                    <th>ID</th>
                                    <th>Name</th>
                                    <th>Score</th>
                                    <th>Actions</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(job, index) in queueInfo.items.reserved" class="reserved-job-row">
                                        <td>{{index + 1}}</td>
                                        <td>{{job.id}}</td>
                                        <td>{{job.displayName}}</td>
                                        <td>{{ getScoreAsDate(job.score) }}</td>
                                        <td>
                                            <button type="button" class="btn btn-success btn-micro" @click="showPayload(job)">Payload</button>
                                        </td>
                                    </tr>
                                    <tr v-if="!queueInfo.items.reserved || queueInfo.items.reserved.length == 0">
                                        <td colspan="3">No reserved jobs found in this queue</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col">
                            <h4>Pending jobs ({{queueInfo.items.pending.length || 0}})</h4>
                            <div class="table-responsive jobs-list-wrapper">
                                <table class="table table-sm" v-if="queueInfo && queueInfo.items && queueInfo.items.pending">
                                    <thead class="thead-light">
                                    <th>#</th>
                                    <th>ID</th>
                                    <th>Name</th>
                                    <th>Actions</th>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(job, index) in queueInfo.items.pending">
                                        <td>{{index + 1}}</td>
                                        <td>{{job.id}}</td>
                                        <td>{{job.displayName}}</td>
                                        <td>
                                            <button type="button" class="btn btn-success btn-micro" @click="showPayload(job)">Payload</button>
                                        </td>
                                    </tr>
                                    <tr v-if="!queueInfo.items.pending || queueInfo.items.pending.length == 0">
                                        <td colspan="3">No pending jobs found in this queue</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col">
                            <h4>Delayed jobs ({{queueInfo.items.delayed.length || 0}})</h4>
                            <div class="table-responsive jobs-list-wrapper">
                                <table class="table table-sm" v-if="queueInfo && queueInfo.items && queueInfo.items.delayed">
                                    <thead class="thead-light">
                                    <th>#</th>
                                    <th>ID</th>
                                    <th>Name</th>
                                    <th>Actions</th>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(job, index) in queueInfo.items.delayed">
                                        <td>{{index + 1}}</td>
                                        <td>{{job.id}}</td>
                                        <td>{{job.displayName}}</td>
                                        <td>
                                            <button type="button" class="btn btn-success btn-micro" @click="showPayload(job)">Payload</button>
                                        </td>
                                    </tr>
                                    <tr v-if="!queueInfo.items.delayed || queueInfo.items.delayed.length == 0">
                                        <td colspan="3">No delayed jobs found in this queue</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary btn-sm" @click="onClose">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SocketService from './../../services/socket.service';
    import moment from 'moment';
    import modalMixin from '../common/modal-mixin';

    export default {
        name: 'detailsModal',
        mixins: [modalMixin],
        props: {
            queue: {
                default: false
            }
        },

        data: function () {
            return {
                queueInfo: null
            }
        },

        mounted(){
            this.loadQueueBaseInfo();
            this.$socketClient.subscribeToQueueChanges(this.queue.name);

            this.$socketClient.events.on('queue_details', (data) => {
                this.queueInfo.items = data.items;
            })
        },

        destroyed(){
            this.$socketClient.unSubscribeFromQueueChanges(this.queue);
        },

        methods: {
            loadQueueBaseInfo(){
                this.$jobsService.queueDetails(this.queue.name).then((response) => {
                    this.queueInfo = response.data;
                });
            },

            getScoreAsDate(score){
                let time = moment.unix(score);
                return time.format("YYYY-MM-DD HH:mm:ss");
            },
            showPayload(job){
                this.$swal({
                    html: `<pre class="code-wrap">${job.data.command}</pre>`,
                    type: 'info',
                    width: 700,
                    buttonsStyling: false,
                    confirmButtonText: 'OK',
                    confirmButtonClass: 'btn btn-sm btn-success popup-btn'
                });
            }
        },

        watch: {
            queue(oldValue, newValue){
                this.$socketClient.unSubscribeFromQueueChanges(oldValue);
                this.$socketClient.subscribeToQueueChanges(newValue);
            }
        }
    }

</script>

<style scoped>

    .jobs-list-wrapper{
        max-height: 500px;
    }

    .modal-dialog.modal-queue-details{
        width: 1200px;
        max-width: 90%;
    }
    .reserved-job-row td{
        background: #97e090;
    }
</style>


// WEBPACK FOOTER //
// src/components/queues/queueDetails.modal.vue